<div class="container" mat-dialog-content>
  <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
  <h2>{{ 'support.title' | translate }}</h2>

  <h3>{{ 'support.subtitle-hr-admin' | translate }}:</h3>
  <div>
    <div class="regions">
      <mat-form-field class="search-field" appearance="outline">
        <mat-label>
          <mat-icon class="search-icon">search</mat-icon>
          {{ 'general.search' | translate }}
        </mat-label>
        <input matInput type="text" [(ngModel)]="searchValue" (ngModelChange)="onSearch($event)" />
        @if (searchValue) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      @for (contactRegion of contactRegions; track contactRegion) {
        <app-action-button
          [design]="regionSelected === contactRegion.region ? 'filled' : 'stroke'"
          (click)="toggleRegion(contactRegion.region)"
          class="region-button"
          >
          {{ contactRegion.region | translate }}
        </app-action-button>
      }

      <div class="contact-list-container">
        @if (displayedContacts.length === 0 && !isSearching) {
          <p>{{ 'support.select-region' | translate }}</p>
        }
        @if (displayedContacts.length === 0 && isSearching) {
          <p>{{ 'support.no-country' | translate }}</p>
        }

        @if (displayedContacts.length) {
          <div class="contact-list">
            @for (contactDetails of displayedContacts; track contactDetails) {
              <div class="contact-entry">
                <p class="contact-entry-item"><img class="flag" src="{{ contactDetails.flagUrl }}" /></p>
                <p class="contact-entry-item">{{ contactDetails.country }}</p>
                <p class="contact-entry-item">{{ contactDetails.organization }}</p>
                <p class="contact">
                  <a [href]="(contactDetails.contact.includes('@') ? 'mailto:' : '') + contactDetails.contact">
                    {{ contactDetails.contact }}
                  </a>
                </p>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <!-- Here Content -->
  @if (supportContent) {
    <div>
      <ng-container>
        <p [innerHTML]="supportContent | translate"></p>
      </ng-container>
    </div>
  }
</div>
